import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

const { block } = createBEMClasses('action-separator');

import './ActionSeparator.css';

export const ActionSeparator = () => {
  const { isMobile } = useViewPort();

  return <>{!isMobile && <div className={block()} />}</>;
};
